import React from "react";
import { Col, Layout, Row } from "antd";
import classNames from "classnames";
import get from "lodash/get";
import { connect } from "react-redux";

import ConsentForm, {ConsentTypes} from "../../components/ConsentTypeMevoV2/ConsentFormMevo";

import { consentServices } from "../../services";

import { getConsentData } from "../../reducers/consent/selectors";
import { consentUpdate } from "../../reducers/consent/actions";

import classes from "./ConsentTypeMevoV2.css";
import { Helmet } from "react-helmet";

import { withNamespaces } from "react-i18next";

const { Content } = Layout;

class Consent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      step: {},
    };
  }

  async componentDidMount() {
    const token = get(this.props, "match.params.token");

    if (this.props.consentData) {
      this.setState({ step: { ...this.props.consentData } });
      this.props.consentUpdate({});
    } else if (token) {
      try {
        const { data } = await consentServices.getConsentMevoV2ByToken(token);
        const step = {
          consentMethodType: get(data, "consentExistsMethodType"),
          who_is_collecting_consent: get(data, "who_is_collecting_consent"),
          ui_content: get(data, "ui_content"),
          initial_form_data: get(data, "initial_form_data"),
          ui_form: get(data, "ui_form"),
          consentPersonType: get(data, "consentExistsPersonType"),
          subjectID: get(data, "subjectID"),
          site_code: get(data, "site_code"),
          authorization_representative_relationship: get(data, "authorization_representative_relationship"),
          authorization_subject_full_name: get(data, "authorization_subject_full_name"),
          had_emergency_consent: get(data, "had_emergency_consent"),
          consentDate: get(data, "consentDate"),
          signature_type: get(data, "signature_type"),
          consent_option: get(data, "consent_option"),
          rccf_option: get(data, "rccf_option"),
          consent_surrogate_relationship: get(data, "details.consent_surrogate_relationship"),
          consent_surrogate_signature: get(data, "details.consent_surrogate_signature"),
          consent_subject_signature: get(data, "details.consent_subject_signature"),
          consent_question_rccf_researchers_share_findings_with_me: get(data, "details.consent_question_rccf_researchers_share_findings_with_me"),
          consent_question_rccf_use_my_research_data: get(data, "details.consent_question_rccf_use_my_research_data"),
          consent_question_rccf_may_take_additional_samples: get(data, "details.consent_question_rccf_may_take_additional_samples"),
          consent_question_rccf_future_contact: get(data, "details.consent_question_rccf_future_contact"),
          rccf_subject_signature: get(data, "details.rccf_subject_signature"),
          consent_investigator_email: get(data, "details.consent_investigator_email"),
          email_consent_signature_order: get(data, "email_consent_signature_order"),
          consent_question_researchers_share_findings_with_me: get(data, "details.consent_question_researchers_share_findings_with_me"),
          consent_question_use_my_research_data: get(data, "details.consent_question_use_my_research_data"),
          consent_question_future_contact: get(data, "details.consent_question_future_contact"),
          consent_question_contact_my_family_doctor: get(data, "details.consent_question_contact_my_family_doctor"),
          randomization_platform_step_3_patient_content: get(data, "randomization_platform_step_3_patient_content"),
          randomization_platform_step_3_surrogate_content: get(data, "randomization_platform_step_3_surrogate_content"),
          has_rand_plat_step_3_emergency_content: get(data, "has_rand_plat_step_3_emergency_content"),
          randomization_platform_step_3_patient_regained_capacity_content: get(data, "randomization_platform_step_3_patient_regained_capacity_content"),
          randomization_platform_step_3_participant_after_deferral_content: get(data, "randomization_platform_step_3_participant_after_deferral_content"),
          randomization_platform_step_3_surrogate_after_deferral_content: get(data, "randomization_platform_step_3_surrogate_after_deferral_content"),
          randomization_platform_step_3_regained_capacity_after_deferral_content: get(data, "randomization_platform_step_3_regained_capacity_after_deferral_content"),
          consent_surrogate_full_name:
            get(data, "details.consent_surrogate_full_name") || undefined,
          consent_subject_email:
            get(data, "details.consent_subject_email") || undefined,
          consent_subject_full_name:
            get(data, "details.consent_subject_full_name") || undefined,
          consent_investigator_full_name:
            get(data, "details.consent_investigator_full_name") || undefined,
          consent_investigator_contact_number:
            get(data, "details.consent_investigator_contact_number") || undefined,
          consent_obtainer_contact_number:
            get(data, "details.second_obtainer_contact_number") || undefined,
          consent_obtainer_full_name:
            get(data, "details.consent_obtainer_full_name") || undefined,
          rccf_investigator_contact_number:
            get(data, "details.rccf_investigator_contact_number") || undefined,
          rccf_subject_full_name:
            get(data, "details.rccf_subject_full_name") || undefined,
          rccf_subject_email:
            get(data, "details.rccf_subject_email") || undefined,
          rccf_investigator_full_name:
            get(data, "details.rccf_investigator_full_name") || undefined,
        };
        this.setState({
          step,
          currentStepPerson: get(data, "consentExistsPersonType"),
        });
      } catch (e) {
        this.props.history.push("/consent_error");
      }
    } else {
      this.props.history.push("/admin/consent");
    }
  }

  sendStep2 = async (params) => {
    const result = await consentServices.createStep2(params);
    const step = {...this.state.step, ui_content: get(result, 'data.content'), ui_form: get(result, 'data.form') };
    this.setState({
      step,
    });
  };


  render() {
    const token = get(this.props, "match.params.token");
    const {
      step: { consentMethodType, consentPersonType },
    } = this.state;

    return (
      <div>
        <Helmet>
          <title>{this.props.i18n.t('NamespaceConsent:Trial Management Portal')}: {this.props.i18n.t('NamespaceConsent:Consent')}</title>
        </Helmet>
        <div>

          <div className={classes.content}>
            <Layout className={classes.parentContainer}>
              <Content className={classes.content}>
                <Row>
                  <Col
                    xs={{ span: 24 }}
                    sm={{ span: 20, offset: 2 }}
                    md={{ span: 16, offset: 4 }}
                    style={{ paddingTop: "4rem", marginBottom: '4rem' }}
                  >
                    <Row type="flex" justify="center">
                      <Col
                        className={classNames(
                          classes.contentWrap,
                          "frosted-card-edm"
                        )}
                        xs={24}
                        sm={18}
                        md={18}
                        lg={20}
                        xl={22}
                      >
                        {(!token ||
                          (token &&
                            consentMethodType &&
                            consentPersonType)) && (
                          <ConsentForm
                            sendStep2={this.sendStep2}
                            token={token}
                            step={{ ...this.state.step }}
                            currentStepPerson={this.state.currentStepPerson}
                            history={this.props.history}
                          />
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Content>
            </Layout>
          </div>

        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  consentData: getConsentData(state),
});

const mapDispatchToProps = { consentUpdate };

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(Consent));



// WEBPACK FOOTER //
// ./src/containers/ConsentTypeMevoV2/ConsentTypeMevoV2.js